import React from "react";

const SearchInput = ({
  value = "",
  placeholder = "Tìm kiếm",
  disabled = false,
  className = "",
  inputClassName = "",
  buttonType = "button",
  submitOnEnter = true,
  onChange,
  onKeyDown,
  onSearch,
}) => {
  const submitSearchImmediately = (searchValue = value, event) => {
    const normalizedValue = String(searchValue ?? "").trim();
    onSearch?.(normalizedValue, {
      immediate: true,
      search_value: normalizedValue,
      event,
    });
  };

  const handleKeyDown = (event) => {
    onKeyDown?.(event);

    if (
      event.defaultPrevented ||
      !submitOnEnter ||
      event.key !== "Enter" ||
      !onSearch
    ) {
      return;
    }

    event.preventDefault();
    submitSearchImmediately(event.currentTarget.value, event);
  };

  return (
    <div
      className={[
        "relative flex h-[42px] w-full items-center rounded-lg border border-gray-300 bg-white px-3 text-base transition-[border-color,box-shadow] duration-150 hover:shadow-sm focus-within:border-2 focus-within:border-blue-500 focus-within:shadow-md",
        disabled ? "cursor-not-allowed opacity-60" : "",
        className,
      ].join(" ")}
    >
      <button
        type={buttonType}
        className="mr-3 flex shrink-0 items-center justify-center disabled:cursor-not-allowed"
        aria-label="Tìm kiếm"
        disabled={disabled}
        onClick={(event) => submitSearchImmediately(value, event)}
      >
        <img
          src="/icons/search-input.svg"
          alt=""
          className="size-3.5 opacity-70"
        />
      </button>

      <input
        type="text"
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        disabled={disabled}
        readOnly={!onChange}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        className={[
          "min-w-0 flex-1 bg-transparent text-base text-gray-900 outline-none placeholder:text-gray-400 disabled:cursor-not-allowed",
          inputClassName,
        ].join(" ")}
      />
    </div>
  );
};

export default SearchInput;
